const EXTRA_INGREDIENT_TYPES = {
  PAIRING: 'PAIRING',
  REFERENCE: 'REFERENCE',
}

export default EXTRA_INGREDIENT_TYPES
